var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-yet-implemented-view"},[_c('h1',{staticClass:"page-title-container"},[_vm._v("Hoppala!")]),_c('p',[_vm._v("Diese Seite existiert (noch) nicht...")])])
}]

export { render, staticRenderFns }